import { styled } from "theme/default/styled";
import { setFlexDFAICJCSA } from "theme/setter/setFlexValues/setFlexDFAICJCSA";

export const SCustomDateTimeContainer = styled.div`
  ${setFlexDFAICJCSA};
`;
